import { Card, Col, Row, Space, Spin } from 'antd';
import React from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import UsageStatistic from './UsageStatistic';
import { faTachometerAltSlow } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '@fortawesome/fontawesome-svg-core';

interface DashboardsUsageListProps {
  company: Company | undefined;
}

export default function DashboardsUsage({
  company,
}: DashboardsUsageListProps) {
    
  const dashboardsUsage = CustomerServiceQueries.useCompanyUsageDashboards(company!.id)

  if (!company)
    return null;

  return (
    <>
    <Card title={<Space><FontAwesomeIcon icon={faTachometerAltSlow as Icon}/> Admin Dashboards</Space>}>
        <Spin spinning={dashboardsUsage.isLoading}>
            
    <Row gutter={[16,16]}>
        {dashboardsUsage.data?.map( item => (
            <Col span={12}>
                <UsageStatistic item={item} />
            </Col>
        ))}
    </Row>
        </Spin>
    </Card>
    </>
  );
}
